import { Currencies } from '../currencies.model';
import Stripe from '@stripe/stripe-js';
import { Ticket } from '../ticket.model';

export enum PaymentProviderType {
  Mangopay = 'mangopay',
  Stripe = 'stripe',
}

// same variable in backend
export const activatedPaymentProvider = [
  PaymentProviderType.Mangopay,
  PaymentProviderType.Stripe,
];

export enum PayoutMethod {
  MangoPayout = 'mgPayout',
  MangoPayinRefund = 'mgPayinRefund',
  StripePayout = 'stripePayout',
}

export const payoutMethodWithKyc = [
  PayoutMethod.MangoPayout,
  PayoutMethod.StripePayout,
];

export const paymentProviderDefaultPayout: {[key in PaymentProviderType]: PayoutMethod} = {
  [PaymentProviderType.Mangopay]: PayoutMethod.MangoPayout,
  [PaymentProviderType.Stripe]: PayoutMethod.StripePayout,
};

export interface PaymentInformation {
  amount: number; // in cent
  currency: Currencies;
}

export type PaymentIntentRes = {
  mangopay: object;
  stripe: Stripe.PaymentIntent;
}

interface PurchaseSucess {
  purchases: Ticket[];
  status: 'success' | 'free';
}

interface PurchasePendingBase {
  provider: unknown;
  paymentData: unknown;
  paymentToken: string;
  status: 'pending';
}

interface MangopayPaymentData extends PurchasePendingBase {
  provider: PaymentProviderType.Mangopay;
  paymentData: {
    SecureModeNeeded: boolean;
    SecureModeRedirectURL: string;
    SecureModeReturnURL: string;
    status: '3DSECURE';
  };
}

interface StripePaymentData extends PurchasePendingBase {
  provider: PaymentProviderType.Stripe;
}

export type PurchaseResponse = PurchaseSucess | StripePaymentData | MangopayPaymentData;

export class UserPaymentProvider {
  public id!: number;

  public providerGeneralConditions: Date;
  public providerId: string;
  public providerType: PaymentProviderType;
  public userInfoId: number;

  public readonly createdAt!: Date;
  public readonly updatedAt!: Date;

  constructor(data: Partial<UserPaymentProvider>) {
    Object.assign(this, data);
  }

}
